<template>
  <input
    class="il-input"
    type="time"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<script>
/*
  A time field that is nothing but the browser's own control.

  Every device already knows how to work this one: a tap opens the system
  picker on an iPhone and on Android, and on a desktop the hour and minute
  boxes take typed digits as well. Its value is the same 24-hour 'HH:mm'
  string this module stored before, whatever the browser draws, so Firestore
  and every formatter are unchanged.

  Whether the boxes read 24-hour or carry an AM/PM field belongs to the
  browser's locale; the .date-hint beside each field spells the value out in
  Israeli format.
*/
export default {
  name: 'IlTimeInput',
  props: { modelValue: { type: String, default: '' } },
  emits: ['update:modelValue'],
}
</script>

<style scoped>
.il-input {
  width: 100%;
  min-width: 120px;
  height: 35px;
  padding: 0 0.6rem;
  border: 0.5px solid lightgrey;
  border-radius: 3px;
  background: #fff;
  font: inherit;
  /* 16px also keeps iOS from zooming the page when the control takes focus */
  font-size: 16px;
  /* The forms turn their container white-on-dark below 600px, and an inherited
     colour would paint this value white on its own white background - unreadable
     on a phone. Both properties are needed: WebKit paints form-control text
     through -webkit-text-fill-color, which wins over colour when inherited. */
  color: #000;
  -webkit-text-fill-color: #000;
  /* App.vue sets direction: rtl on every element; a clock time is read left
     to right. Blink ignores this on its own time control - it orders hour and
     minute by the browser's locale either way - but engines that do honour it
     keep 07:16 from being drawn as 16:07 */
  direction: ltr;
  text-align: left;
  outline: none;
}
.il-input:hover,
.il-input:focus {
  border: 1.1px solid lightblue;
}

/* Safari and iOS draw the value through this one */
.il-input::-webkit-date-and-time-value {
  color: #000;
  -webkit-text-fill-color: #000;
}
/* Chrome and Android draw the editable segments through these */
.il-input::-webkit-datetime-edit {
  color: #000;
  -webkit-text-fill-color: #000;
}
.il-input::-webkit-datetime-edit-text {
  color: #000;
  -webkit-text-fill-color: #000;
}
.il-input::-webkit-datetime-edit-hour-field,
.il-input::-webkit-datetime-edit-minute-field,
.il-input::-webkit-datetime-edit-ampm-field {
  color: #000;
  -webkit-text-fill-color: #000;
}
</style>
